import { IRecordType } from "../types/schema"

const humanisedRecordNames: { [K in IRecordType]?: string } = {
  FlowResult: "Result",
  FlowGroup: "Group",
  FileFolder: "Folder",
  HelpRequest: "Help Request",
  Resolution: "Help Item",
  ResolutionFolder: "Help Folder",
  TranscriptItem: "Transcript Item",
  InformationItem: "Information Item",
  Plan: "Plan",
  FeatureHighlight: "Update",
  ActionTag: "Feature Tag",
  RiskNote: "Note",
  HrProfile: "Profile",
  HrJob: "Job",
  Review: "Review",
  CompanyLink: "Link",
  TranscriptFolder: "Transcript Folder",
  AlertGroup: "Alert Group",
  flowResultLocation: "Location",
  FlowTag: "Flow Tag",
  ProgressTag: "Progress Tag",
  RotaShiftType: "Entry Type",
}

export function formattedRecordName(recordName: IRecordType) {
  return humanisedRecordNames[recordName] ?? recordName
}
